// Toggle an interactive checklist box inside RENDERED (read-mode) HTML.
// Returns the container's new innerHTML to persist, or null if the click
// wasn't on a checkbox. Checked-state is a CLASS (cg-done) — it survives
// Odoo's sanitizer on both descriptions and comments (data-* does not).
export function toggleCheckboxAt(target: EventTarget | null, containerSelector = '.cg-prose'): string | null {
  const t = target as HTMLElement | null;
  if (!t?.classList?.contains('cg-check-box')) return null;
  const li = t.closest('li');
  if (!li) return null;
  const done = li.classList.contains('cg-done') || li.getAttribute('data-checked') === 'true';
  li.removeAttribute('data-checked'); // clear any legacy encoding
  li.classList.toggle('cg-done', !done);
  const container = t.closest(containerSelector) as HTMLElement | null;
  return container ? container.innerHTML : null;
}
